import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const DemoConfirmation: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4 py-16">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-xl text-center">
        {/* Logo and Thank You message */}
        <div className="flex flex-col items-center space-y-4">
          <img
            src="/logo.jpeg"
            alt="ShreeGuruCool"
            className="h-20 w-20 object-contain rounded-full shadow-md"
          />
          <h1 className="text-3xl font-bold text-gray-900">Thank You!</h1>
          <CheckCircle className="h-12 w-12 text-green-500" />
        </div>

        {/* Confirmation Message */}
        <p className="mt-6 text-lg text-gray-700">
          Your request for a demo class has been successfully submitted. We appreciate your interest in ShreeGuruCool!
        </p>
        <p className="mt-2 text-gray-600">
          A representative will contact you shortly to confirm the details of your session. Please check your email for a confirmation.
        </p>

        {/* Action Button */}
        <Link
          to="/"
          className="mt-8 inline-block bg-blue-600 text-white font-medium px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors shadow-md"
        >
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};

export default DemoConfirmation;